// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__2uJ70","description":"MealItem_description__2YINS","price":"MealItem_price__3sNYl"};